import type { FaireProductEntity } from "../../entity_types/product";

export const p_w9uu7n3abs: FaireProductEntity = {
  token: "p_w9uu7n3abs",
  type: "product",
  name: "Flor de Madera, 10mL Perfume Travel Spray",
  brandToken: "b_c3hepkjc1t",
  brandName: "Nopalera",
  imageUrl:
    "https://cdn.faire.com/fastly/100b3b59c28787ea3271a4d9de6894f46d8143b4ca8ea8610190577190edb79d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1b8cd825f9320b3bb9ef2f4b0a62a99a040a5f952b246384b272dc9cccba58f3.jpeg",
    "https://cdn.faire.com/fastly/1b408772c6fc8753261e9983e90ddcb31e490a1a74a8d7d440801934664977d6.jpeg",
    "https://cdn.faire.com/fastly/a692b14f03ec9088b2d58c0f9c3b2015303cc1f9deae6b1187f64e56b71e9efc.jpeg",
    "https://cdn.faire.com/fastly/484716971bb4613b1eac6d7fc6a2c57972b344a9921a42ec7f58323a7288ce5e.jpeg",
    "https://cdn.faire.com/fastly/d2b4c5989b15c67f5ee07367ce0fe7153bcbaece0c03ec15438a6cb14e338b36.jpeg",
  ],
  priceDollars: 15,
  description:
    "\n10mL spritzer, travel spray\n\nFresh and seductive, Flor de Madera eau de parfum is inspired by the ancient canals of Mexico City, where nature and mystery intertwine. Bright tamarind and Mexican citrus blend with soft violet, jasmine petal, and vetiver, while musk and cedarwood add a sensual, lasting depth. Ideal for those who embrace new beginnings and bold adventures every day. \n\nTOP: Tamarind, Mexican Citrus \nMID: Violet, Jasmine Petal, Vetiver \nBASE: Musk, Cedarwood\n\nClean formulation with no phthalates, parabens or sulfates\nVegan | Cruelty free | Gluten free\n\nInstructions for use: Spray on pulse points, where  skin is naturally warmer. These areas include the wrists, behind the ears, the inner elbows. The warmth will help to release the fragrance throughout the day. Keep your perfume in a cool, dry place away from direct sunlight and heat to preserve its integrity and longevity.\n\n\nWe are a clean brand. Our products are vegan and free from hormone disruptors and phthalates.",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-31T16:21:01.579Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
